import React, { useEffect, useState } from "react";
import { usersApi, assignApi, apiErrorMessage } from "@/api/client";
import { Sheet } from "@/components/Sheet";
import { toast } from "sonner";

const CALL = {
  organisation: (id, body) => assignApi.organisation(id, body),
  opportunity: (id, body) => assignApi.opportunity(id, body),
  task: (id, body) => assignApi.task(id, body),
  visit: (id, body) => assignApi.visit(id, body),
};

export function AssignDialog({ open, onOpenChange, entityType, entityId, currentUserId, onSaved }) {
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState(currentUserId || "");
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setSelected(currentUserId || "");
      usersApi.list().then((r) => setUsers(r.data.items.filter((u) => u.active !== false))).catch(() => {});
    }
  }, [open, currentUserId]);

  const submit = async () => {
    setSaving(true);
    try {
      await CALL[entityType](entityId, { user_id: selected || null, reason: reason || null });
      toast.success(selected ? "Assigned" : "Unassigned");
      onOpenChange(false);
      onSaved?.();
    } catch (e) { toast.error(apiErrorMessage(e)); } finally { setSaving(false); }
  };

  return (
    <Sheet open={open} onClose={() => onOpenChange(false)} title="Assign / Reassign" testid="assign-dialog">
      <label className="mb-1 block text-xs font-semibold text-slate-600">Assign to</label>
      <select data-testid="assign-user-select" value={selected} onChange={(e) => setSelected(e.target.value)}
        className="mb-3 min-h-[44px] w-full rounded-lg border border-slate-200 px-3 text-sm">
        <option value="">— Unassigned (pool) —</option>
        {users.map((u) => (
          <option key={u.id} value={u.id}>{u.display_name || u.name} · {u.role?.replace(/_/g, " ")}</option>
        ))}
      </select>
      <label className="mb-1 block text-xs font-semibold text-slate-600">Reason (optional)</label>
      <input data-testid="assign-reason-input" value={reason} onChange={(e) => setReason(e.target.value)}
        className="mb-4 min-h-[44px] w-full rounded-lg border border-slate-200 px-3 text-sm" placeholder="e.g. territory match" />
      <button data-testid="assign-submit" onClick={submit} disabled={saving}
        className="min-h-[48px] w-full rounded-lg bg-teal-700 font-semibold text-white hover:bg-teal-800 disabled:opacity-60">
        {saving ? "Saving…" : "Confirm"}
      </button>
    </Sheet>
  );
}
